import React, { useEffect } from "react";
import './Services.css';

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner
  }, []); // Empty dependency array ensures it runs only once on mount
  
  return (
    <div className="services-page">
      <div className="container">
        <h1>Products & Services</h1>
        
        {/* Logo Watermark */}
        <div className="logo-watermark">
          <img src="/logo.png" alt="Zenith World Wide Logo" className="watermark-logo" />
        </div>
        
        <section className="services-overview">
          <h2>Our Comprehensive Solutions</h2>
          <p>At Zenith World Wide, we offer a wide range of services and products designed to meet the diverse needs of modern businesses. Our solutions are tailored to help you achieve your goals efficiently and effectively.</p>
        </section>

        <section className="services-grid">
          <div className="service-category">
            <h2>Contracting & Construction</h2>
            <div className="service-items">
              <div className="service-item">
                <h4>We provide complete contracting and construction solutions with a focus on quality, safety, and timely delivery. Our team manages projects from start to finish — including planning, design, approvals, and execution. Whether it’s residential, commercial, or industrial projects, we ensure strong foundations, reliable structures, and cost-effective solutions. Our goal is to deliver projects that meet client expectations and add long-term value.</h4>
               
              </div>
              
            </div>
          </div>

          <div className="service-category">
            <h2>Manpower Services</h2>
            <div className="service-items">
              <div className="service-item">
                <h4>We provide skilled and unskilled manpower to meet the needs of different industries. Our recruitment process ensures that every worker is trained, reliable, and ready to deliver quality work. From construction labor and technical staff to administrative and support teams, we supply manpower that helps businesses run smoothly and efficiently.</h4>
                
              </div>
             
            </div>
          </div>

          <div className="service-category">
            <h2>IT & Digital Solutions</h2>
            <div className="service-items">
              <div className="service-item">
                <h4>We deliver innovative IT and digital solutions to help businesses stay ahead in today’s fast-changing world. Our services include software development, web and mobile applications, digital marketing, cloud With a focus on reliability and performance, we create technology that makes work easier, faster, and more efficient — helping our clients grow and succeed in the digital era.solutions, and IT support.</h4>
                
              </div>
             
            </div>
          </div>

          <div className="service-category">
            <h2>General Services</h2>
            <div className="service-items">
              <div className="service-item">
                <h4>We provide a wide range of general services designed to support individuals and businesses in their day-to-day needs. From facility management and maintenance to logistics, cleaning, and administrative support, our team ensures reliable, cost-effective, and timely service delivery.Our focus is on convenience, quality, and customer satisfaction, making us a trusted partner for all your service requirements.</h4>
                
              </div>
             
            </div>
          </div>

          <div className="service-category">
            <h2>Products</h2>
            <div className="service-items">
              <div className="service-item">
                <h3>
                <ul>
                  <li>Building Materials</li>
                  <li>Oil & Gas Spare parts</li>
                  <li>IT Hardware</li>
                  <li>General Products</li>
                </ul>
                </h3>
              </div>
             
            </div>
          </div>

          {/*<div className="service-category">
            <h2>Support & Maintenance</h2>
            <div className="service-items">
              <div className="service-item">
                <h3>24/7 Technical Support</h3>
                <p>Round-the-clock technical support to ensure your systems run smoothly.</p>
                <ul>
                  <li>24/7 helpdesk support</li>
                  <li>Remote troubleshooting</li>
                  <li>System monitoring</li>
                  <li>Emergency response services</li>
                </ul>
              </div>
              <div className="service-item">
                <h3>Maintenance Services</h3>
                <p>Regular maintenance and updates to keep your systems secure and up-to-date.</p>
                <ul>
                  <li>Regular system updates</li>
                  <li>Security patches</li>
                  <li>Performance optimization</li>
                  <li>Backup and recovery services</li>
                </ul>
              </div>
            </div>
          </div>*/}
        </section>

        <section className="cta-section">
          <h2>Ready to Get Started?</h2>
          <p>Contact us today to discuss how our services and products can help your business achieve its goals.</p>
          <a href="/contact" className="cta-button">Contact Us</a>
        </section>
      </div>
    </div>
  );
};

export default Services;
